<template>
  <div class="blog-area pt-100 pb-75">
    <div class="container mw-1356">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <div class="section-title mw-860">
          <span class="top-title">المدونة</span>
          <h2>أحدث المقالات والنصائح لكم</h2>
        </div>
        <RouterLink to="/blog" class="read-more style-two text-grey-teal">
          عرض جميع المقالات
          <i class="ti ti-arrow-left"></i>
        </RouterLink>
      </div>

      <div class="row">
        <div
          v-for="(post, index) in blogPosts"
          :key="index"
          :class="getColumnClass(index)"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="blog-single-item transition-y">
            <RouterLink :to="post.detailsLink" class="d-block blog-img">
              <img :src="post.image" :alt="post.title" />
            </RouterLink>

            <div class="blog-content">
              <RouterLink :to="post.tagLink" class="tag">
                {{ post.category }}
              </RouterLink>
              <h3>
                <RouterLink :to="post.detailsLink">{{ post.title }}</RouterLink>
              </h3>
              <ul class="d-flex align-items-center flex-wrap ps-0 mb-0">
                <li class="d-flex align-items-center">
                  <i class="ti ti-calendar-week"></i>
                  <span>{{ post.date }}</span>
                </li>
                <li class="d-flex align-items-center">
                  <i class="ti ti-clock"></i>
                  <span>قراءة {{ post.readTime }} دقائق</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "IptvLatestArticles",
  setup() {
    const blogPosts = ref([
      {
        title:
          "دليلك الشامل لتشغيل اشتراك IPTV على الشاشات الذكية (Smart TV) بدون تعقيد",
        category: "أدلة التشغيل",
        date: "23 يناير، 2026",
        readTime: 5,
        image: require("@/assets/images/blog-1.jpg"),
        detailsLink: "/blog-details",
        tagLink: "/tags",
      },
      {
        title: "كيف تتخلص من مشكلة تقطيع البث أثناء المباريات الكبيرة؟",
        category: "حلول تقنية",
        date: "22 يناير، 2026",
        readTime: 3,
        image: require("@/assets/images/blog-2.jpg"),
        detailsLink: "/blog-details",
        tagLink: "/tags",
      },
      {
        title: "أفضل تطبيقات تشغيل IPTV لعام 2026 ومميزات كل منها...",
        category: "مراجعات",
        date: "21 يناير، 2026",
        readTime: 2,
        image: require("@/assets/images/blog-3.jpg"),
        detailsLink: "/blog-details",
        tagLink: "/tags",
      },
    ]);

    const getColumnClass = (index: number) => {
      return index === 0 ? "col-lg-6" : "col-lg-3 col-md-6";
    };

    return {
      blogPosts,
      getColumnClass,
    };
  },
});
</script>